import { useNavigate, Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import Logo from "@/components/Logo";

const DIVISIONS = [
  { slug: "home-appliances", label: "Konattu Home Appliances" },
  { slug: "inhome", label: "Konattu InHome" },
  { slug: "hypermart", label: "Konattu Hypermart" },
  { slug: "kitchen-lounges", label: "Kitchen Lounges" },
  { slug: "emilia", label: "Emilia, The Beauty Hub" },
];
const LINKS = [
  { id: "about", label: "Our Story" },
  { id: "divisions", label: "Divisions" },
  { id: "network", label: "Locations" },
  { id: "offers", label: "Mood Offers" },
  { id: "contact", label: "Contact" },
];
const SOCIALS = [
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/konattu-group/", Icon: Linkedin },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/konattugroup", Icon: Facebook },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/konattugroup", Icon: Instagram },
  { id: "youtube", label: "YouTube", href: "https://youtube.com/@konattugroup4603", Icon: Youtube },
];

export const Footer = () => {
  const nav = useNavigate();
  const go = (id) => {
    if (window.location.pathname === "/" && window.__lenis) window.__lenis.scrollTo(`#${id}`, { offset: -70 });
    else nav(`/#${id}`);
  };

  return (
    <footer className="bg-konattu-maroon text-[#F7F2E9]" data-testid="footer">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-[#F7F2E9]/15">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 font-body text-[#F7F2E9]/70 max-w-sm text-[15px] leading-relaxed">
              Your quality shopping partner since 1998. Adding value to life across Kerala.
            </p>
            <p className="mt-5 font-mono text-sm text-[#F7F2E9]/80">
              <a href="tel:8086568787" className="hover:text-konattu-red transition-colors">+91 80865 68787</a>
              <span className="text-[#F7F2E9]/40"> · </span>
              <a href="tel:8111803387" className="hover:text-konattu-red transition-colors">+91 81118 03387</a>
            </p>
            <p className="mt-3 font-mono text-sm text-[#F7F2E9]/80">
              <a href="mailto:info@konattugroup.com" data-testid="footer-email-info" className="hover:text-konattu-red transition-colors">info@konattugroup.com</a>
              <span className="text-[#F7F2E9]/40"> · </span>
              <a href="mailto:hr@konattugroup.com" data-testid="footer-email-hr" className="hover:text-konattu-red transition-colors">hr@konattugroup.com</a>
            </p>
            <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
              {SOCIALS.map(({ id, label, href, Icon }) => (
                <a
                  key={id}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${id}`}
                  className="w-10 h-10 inline-flex items-center justify-center border border-[#F7F2E9]/20 rounded-full text-[#F7F2E9]/75 hover:text-white hover:bg-konattu-red hover:border-konattu-red transition-colors duration-300"
                >
                  <Icon size={16} strokeWidth={1.75} />
                </a>
              ))}
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono text-[11px] tracking-[0.3em] text-konattu-yellow mb-5">EXPLORE</div>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button onClick={() => go(l.id)} data-testid={`footer-link-${l.id}`} className="font-body text-[#F7F2E9]/75 hover:text-konattu-red transition-colors">{l.label}</button>
                </li>
              ))}
              <li><Link to="/careers" data-testid="footer-link-careers" className="font-body text-[#F7F2E9]/75 hover:text-konattu-red transition-colors">Careers</Link></li>
              <li><Link to="/blog" data-testid="footer-link-blog" className="font-body text-[#F7F2E9]/75 hover:text-konattu-red transition-colors">Journal</Link></li>
              <li><Link to="/admin" data-testid="footer-link-admin" className="font-body text-[#F7F2E9]/50 hover:text-konattu-red transition-colors text-sm">Admin</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="font-mono text-[11px] tracking-[0.3em] text-konattu-yellow mb-5">OUR DIVISIONS</div>
            <ul className="space-y-3">
              {DIVISIONS.map((d) => (
                <li key={d.slug}>
                  <Link to={`/division/${d.slug}`} data-testid={`footer-division-${d.slug}`} className="font-body text-[#F7F2E9]/75 hover:text-konattu-red transition-colors">{d.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-sm text-[#F7F2E9]/50">© {new Date().getFullYear()} Konattu Group · Thengana, Kottayam, Kerala</p>
          <p className="font-mono text-[11px] tracking-[0.25em] text-[#F7F2E9]/60">
            YOUR QUALITY <span className="text-konattu-red">SHOPPING</span> PARTNER
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
